module.exports = __webpack_public_path__ + "img/maestro-notext.a7a37701.svg";